// extracted by mini-css-extract-plugin
export var button = "styles-module__button___ggQQD";
export var buttonContainer = "styles-module__buttonContainer___apUuk";
export var close = "styles-module__close___J3kD5";
export var container = "styles-module__container___P8C21";
export var contentContainer = "styles-module__contentContainer___N2J6L";
export var fadeIn = "styles-module__fadeIn___nSNM_";
export var phoneContainer = "styles-module__phoneContainer___pQKmO";
export var ratingContainer = "styles-module__ratingContainer___yJoiU";
export var starRating = "styles-module__starRating___u31mN";
export var text = "styles-module__text___FeRkg";
export var textContainer = "styles-module__textContainer___fdQMm";